import { Text } from '@billy/design-system'

import * as Styled from './styles'

interface HeaderProps {
  count: number
  title: string
}

export const Header = ({ count, title }: HeaderProps) => {
  return (
    <Styled.HeaderWrapper>
      <Text weight="bold">{count}</Text>
      <Text weight="bold">{title}</Text>
    </Styled.HeaderWrapper>
  )
}
